// Hardcoded RIA settings for DEV environment (riaId: 245)
// Source: GET /serviceToken/v1/advisor/riaFirm/245
// Source: GET /serviceToken/v1/advisor/riaLabelSettings/245
// Source: GET /serviceToken/v1/advisor/riaFirm/riaUrl?riaLoginUrl=principal.dev.rwsystems.io
const getRiaId = () => window.rwOptions?.RIA_ID || 245;

const devRiaSettings = () => ({
  // From riaLabelSettings response
  riaFontSize: '14px',
  riaFontFamily: 'Open Sans',
  riaHeaderColor: '#0091DA',
  riaBgImage: 'assets/img/background/loginbg_2.png',
  riaDisclaimer:
    '&lt;p&gt;Principal&amp;reg; SimpleInvest is a discretionary investment advisory program that offers diversified investment portfolios for a fee. Principal&amp;reg; SimpleInvest is sponsored and managed by Principal Advised Services, LLC, which consults with Principal Global Investors, LLC, in the creation of the portfolios and the selection of the underlying portfolio investments. Trading and execution services provided by RobustWealth, Inc., Principal Advised Services, LLC, Principal Global Investors, LLC, and RobustWealth, Inc. are members of the Principal Financial Group&amp;reg;. Brokerage and custodial services provided by Apex Clearing Corporation, member FINRA, NYSE and&amp;nbsp;&lt;a title=&quot;SIPC&quot; href=&quot;https://www.sipc.org/&quot;&gt;SIPC&lt;/a&gt;. Apex Clearing Corporation is not affiliated with any member of the Principal Financial Group&amp;reg;. Principal&amp;reg; SimpleInvest portfolios are comprised primarily of Principal&amp;reg; products, including affiliated mutual funds and ETFs.&lt;/p&gt;\n&lt;p&gt;Please refer to the&amp;nbsp;&lt;a title=&quot;Form ADV for Principal Advised Services, LLC&quot; href=&quot;https://secure02.principal.com/publicvsupply/GetFile?fm=PAS8A-0&amp;amp;ty=VOP&quot;&gt;Form ADV for Principal Advised Services, LLC&lt;/a&gt;, and&amp;nbsp;&lt;a title=&quot;other applicable disclosures and agreements&quot; href=&quot;https://www.principal.com/principal-advised-services-legal-documents&quot;&gt;other applicable disclosures and agreements&lt;/a&gt;&amp;nbsp;for important information about Principal&amp;reg; SimpleInvest and its services, fees and related conflicts of interest. All investments have inherent risks. Investing in Principal&amp;reg; SimpleInvest portfolios does not guarantee profit or protect against loss.&lt;/p&gt;\n&lt;p&gt;Principal, Principal and symbol design, and Principal Financial Group are trademarks and service marks of Principal Financial Services, Inc., a member of the Principal Financial Group&amp;reg;, Des Moines, IA 50392.&lt;/p&gt;',
  riaSidebarColor: 'sidebar-robustRIA-default',
  riaRectangleLogo: `uploads/rect_${getRiaId()}.png`,
  riaSquareLogo: `uploads/square_${getRiaId()}.png`,
  riaFavicon: 'uploads/ria/64/image-20201021-194003_1612383973022.png',
  riaEmailDisclaimer: 'ria_email_disclaimer_text for ria id - **5',
  riaHeaderFontColor: '#ffffff',
  riaSidebarFontColor: '#240303',
  riaHeaderHoverColor: '#354552',
  totalPortfolioValueLogo: 'uploads/thumbnails/ria/64/portalsettings/ic-portfolio.svg',
  totalGoalsValueLogo: 'uploads/thumbnails/ria/64/portalsettings/ic-portfolio.svg',
  // From riaFirm response
  riaId: getRiaId(),
  companyName: 'Principal Advised Services',
  companyLegalName: 'Principal Advised Services',
  website: 'http://principal.com',
  contactPageLink: 'None',
  firmParameter: 'principal',
  loginLink: 'poc-principal.dev.rwsystems.io',
  phoneNumber: '1-833-416-7231',
  allowRegister: 0,
  enterpriseId: 3,
  hasCustomDomain: 1,
  logo: `uploads/square_${getRiaId()}.png`,
  headerColor: '#0091DA',
  onboardingSource: 'ADVISOR',
  // From searchRiaFirmFromUrl response (riaFirm/riaUrl)
  requestedLoginLink: 'principal.dev.rwsystems.io',
  riaIarType: 0,
  riaTypeId: 0,
  riaMaskDemoId: 1,
  phoneNumber2: null,
  email1: 'vaibhav.robustwealth@gmail.com',
  crdNum: '435345',
  primaryOffice: 'Principle Dev2',
  primaryContactName: 'Vaibhav',
  defPrimaryUser: 90496,
  bccEmailAddress: null,
});

export default devRiaSettings;
